import { useState } from 'react';

import { cn } from '../utils';

interface UserAvatarProps {
  photoURL?: string;
  /** Already-resolved display name — the monogram is derived from it. */
  initials: string;
  alt?: string;
  /** Sizing + typography come from the caller: the artboards draw four sizes. */
  className?: string;
  /** Brand-filled circle marks a client with live bids (the artboard's `avBg`). */
  tone?: 'fill' | 'brand';
}

/**
 * Client monogram — `Redesign-D-Admin{,-Mobile}`, the circle in front of every
 * client row and at the head of the detail screen.
 *
 * The artboard fills it with the brand colour when the client has active bids
 * and with the flat grey otherwise: the list is scanned for "who is mid-auction
 * right now", so that one is a status, not decoration.
 */
export function UserAvatar({ photoURL, initials, alt, className, tone = 'fill' }: UserAvatarProps) {
  const [imageError, setImageError] = useState(false);

  return (
    <div
      className={cn(
        'flex flex-shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold',
        tone === 'brand' ? 'bg-cf-brand text-white' : 'bg-cf-fill text-cf-ink-muted',
        className,
      )}
    >
      {photoURL && !imageError ? (
        <img
          src={photoURL}
          alt={alt ?? initials}
          className="h-full w-full object-cover"
          onError={() => setImageError(true)}
        />
      ) : (
        initials
      )}
    </div>
  );
}
